import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import { Input } from '../../components/ui/Input';
import { empresasApi } from '../../api/admin';
import { useAuth } from '../../context/AuthContext';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

const FORM_VAZIO = { chave_pix: '', banco: '', agencia: '', conta: '', digito: '' };

export default function DadosBancariosEmpresa() {
  useTituloPagina('Dados Bancários e Pix');
  const { tenantId } = useAuth();
  const [empresas, setEmpresas] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [form, setForm] = useState(FORM_VAZIO);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = () => empresasApi.listar(tenantId).then(setEmpresas).catch(() => {});
  useEffect(() => { carregar(); }, [tenantId]); // eslint-disable-line

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));

  const abrirEdicao = (emp) => {
    setForm({
      chave_pix: emp.chave_pix || '', banco: emp.banco || '', agencia: emp.agencia || '',
      conta: emp.conta || '', digito: emp.digito || ''
    });
    setErro('');
    setEditandoId(emp.id);
  };

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    setErro('');
    try {
      await empresasApi.atualizar(editandoId, form);
      setEditandoId(null);
      carregar();
    } catch (err) {
      setErro(err.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <Card>
        <p style={{ fontSize: 13, color: COLORS.textMid, marginTop: 0 }}>
          Chave Pix e dados bancários de cada empresa (CNPJ) — aparecem na proposta impressa pra facilitar o pagamento do cliente.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {empresas.map(emp => (
            <div key={emp.id} style={{ border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: '14px 16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: editandoId === emp.id ? 14 : 0 }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{emp.nome}</div>
                  <div style={{ fontSize: 12, color: COLORS.textMid }}>{emp.cnpj || 'sem CNPJ'}</div>
                </div>
                {editandoId !== emp.id && <Btn tamanho="sm" variante="ghost" onClick={() => abrirEdicao(emp)}>Editar</Btn>}
              </div>

              {editandoId === emp.id && (
                <form onSubmit={salvar} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, borderTop: `1px solid ${COLORS.border}`, paddingTop: 14 }}>
                  <Input label="Chave Pix" value={form.chave_pix} onChange={e => onChange('chave_pix', e.target.value)} style={{ gridColumn: '1 / -1' }} />
                  <Input label="Banco" value={form.banco} onChange={e => onChange('banco', e.target.value)} />
                  <Input label="Agência" value={form.agencia} onChange={e => onChange('agencia', e.target.value)} />
                  <Input label="Conta" value={form.conta} onChange={e => onChange('conta', e.target.value)} />
                  <Input label="Dígito" value={form.digito} onChange={e => onChange('digito', e.target.value)} />
                  {erro && <p style={{ gridColumn: '1 / -1', color: COLORS.danger, fontSize: 13, margin: 0 }}>{erro}</p>}
                  <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 10 }}>
                    <Btn variante="ghost" onClick={() => setEditandoId(null)} type="button">Cancelar</Btn>
                    <Btn type="submit" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
                  </div>
                </form>
              )}

              {editandoId !== emp.id && (emp.chave_pix || emp.banco) && (
                <div style={{ fontSize: 12, color: COLORS.textMid, marginTop: 8, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                  {emp.chave_pix && <span>Pix: <strong>{emp.chave_pix}</strong></span>}
                  {emp.banco && <span>Banco: <strong>{emp.banco}</strong></span>}
                  {emp.agencia && <span>Agência: <strong>{emp.agencia}</strong></span>}
                  {emp.conta && <span>Conta: <strong>{emp.conta}{emp.digito ? `-${emp.digito}` : ''}</strong></span>}
                </div>
              )}
            </div>
          ))}
          {empresas.length === 0 && <p style={{ color: COLORS.textMid, fontSize: 13 }}>Nenhuma empresa cadastrada.</p>}
        </div>
      </Card>
    </div>
  );
}
